import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

const ThankYouDialog = ({ open, onClose }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: '32px',
                        cursor: 'pointer',
                    },
                    onClick: onClose,
                },
            }}
        >
            <DialogTitle
                sx={{
                    textAlign: 'center',
                    fontSize: '2rem',
                    lineHeight: 1.3,
                }}
            >
                Thank you for<br />your purchase!
            </DialogTitle>
            <DialogContent
                sx={{
                    p: 0,
                    paddingTop: 2,
                    width: '80vw',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    flexDirection: 'column',
                }}
            >
                <div
                    style={{
                        width: '100%',
                        textAlign: 'center',
                        fontStyle: 'italic',
                        color: '#777',
                        fontSize: '1rem',
                    }}
                >
                    click anywhere to close
                </div>
                <img
                    src="ty.gif"
                    alt="Funny Dog"
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: '32px',
                    }}
                />
            </DialogContent>
        </Dialog>
    );
};

export default ThankYouDialog;